export default __webpack_public_path__ + "static/entertainment-spin-cube-74714daeb4eafb87202e390caf6849cf.gif";